import clickOutside from '@gro-up/ui/swk/composables/clickOutside';

// Registers the `v-click-outside` directive the TooltipElement relies on.
// Client-only because the directive touches `document`.
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('click-outside', clickOutside);
});
